
import { z } from "zod";

export const PhoneCallStatusValues = ["ABANDONED", "ANSWERED", "BUSY", "CANCELED", "COMPLETED", "FAILED", "FORWARDED", "IN_PROGRESS", "INITIATED", "MISSED", "NO_ANSWER", "QUEUED", "RINGING"] as const;
export const PhoneCallStatusSchema = /* @__PURE__ */ z.enum(PhoneCallStatusValues);
export const PhoneCallStatus: (typeof PhoneCallStatusSchema)["enum"] = { "ABANDONED": "ABANDONED", "ANSWERED": "ANSWERED", "BUSY": "BUSY", "CANCELED": "CANCELED", "COMPLETED": "COMPLETED", "FAILED": "FAILED", "FORWARDED": "FORWARDED", "IN_PROGRESS": "IN_PROGRESS", "INITIATED": "INITIATED", "MISSED": "MISSED", "NO_ANSWER": "NO_ANSWER", "QUEUED": "QUEUED", "RINGING": "RINGING" };
export type PhoneCallStatus = (typeof PhoneCallStatusValues)[number];
export const PhoneCallStatusDisplayNames = { "ABANDONED": "Abandoned",
"ANSWERED": "Answered",
"BUSY": "Busy",
"CANCELED": "Canceled",
"COMPLETED": "Completed",
"FAILED": "Failed",
"FORWARDED": "Forwarded",
"IN_PROGRESS": "In Progress",
"INITIATED": "Initiated",
"MISSED": "Missed",
"NO_ANSWER": "No Answer",
"QUEUED": "Queued",
"RINGING": "Ringing", } satisfies Record<PhoneCallStatus, string>;
